import { render, staticRenderFns } from "./FarmingRecordNewAdd.vue?vue&type=template&id=fd34a5a8"
import script from "./FarmingRecordNewAdd.vue?vue&type=script&lang=js"
export * from "./FarmingRecordNewAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports